const global = {
  // local
  config: {
    // websiteBaseName: "/reactquiz/",
    websiteBaseName: "/revelation/",
    // websiteBaseName: "/",

    // apiBaseUrl: "http://localhost/qbbackend/",
    apiBaseUrl: "https://acts238games.com/qbbackend/",

    QSID: "5",                        // FLAG-QSID
    // Performance Metrics
    dGameInit: "",
    dQSLoaded: "",
    // Security Parameters
    sessionID: "",
    authToken: "",
    // Debugging Parameters    
    debugQuestionType: "",            // FLAG-DEBUG-QUESTIONTYPE
    debugQuestionModified: "",
  },
};

export default global;
